import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const RoleBasedRouter: React.FC = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // Redirect based on user role
      switch (user.role) {
        case 'super_admin':
        case 'admin':
          // Both super_admin and admin should access the admin panel
          window.location.href = '/admin';
          break;
        case 'agent':
          // Agents should go to the agent dashboard
          window.location.href = '/agent';
          break;
        default:
          // Regular members or other roles should go to the main site
          window.location.href = '/';
          break;
      }
    }
  }, [user]);

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  // Show loading while redirecting
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      backgroundColor: '#0A0A0A',
      color: '#FFD700'
    }}>
      Redirecting to your dashboard...
    </div>
  );
};

export default RoleBasedRouter;